import {ADD_MESSAGE, ADD_FAKE_MESSAGE, SEND_MESSAGE, UPLOAD_FILE, UPLOAD_FILE_PROGRESS} from '../actions';
import MessageFactory from '../services/messageFactory';
import findIndex from 'lodash/findIndex';

function activityExist({messages, activityId, clientReferenceId}) {
  return findIndex(messages, {activityId}) !== -1 ||
    findIndex(messages, {activityId: clientReferenceId}) !== -1;
}

function updateMessage(messages, clientReferenceId, updateInfo) {
  return messages.map(message =>
    message.activityId === clientReferenceId ?
      Object.assign({}, message, updateInfo) :
      message
  );
}

function onSendFulfilled({messages, clientReferenceId, newId, dateTime}) {
  return updateMessage(messages, clientReferenceId, {activityId: newId, dateTime});
}

function onSendRejected({messages, clientReferenceId}) {
  return updateMessage(messages, clientReferenceId, {error: true});
}

function onUploadRejected({messages, clientReferenceId, media}) {
  const mediaWithError = Object.assign({}, media, {error: true});
  return updateMessage(messages, clientReferenceId, {media: [mediaWithError]});
}

export default function conversationHistory(state = [], action) {
  switch (action.type) {
    case `${SEND_MESSAGE}_PENDING`:
    case `${ADD_MESSAGE}`:
    case `${ADD_FAKE_MESSAGE}`:
    case `${UPLOAD_FILE}_PENDING`:
      if (!activityExist({
        messages: state,
        activityId: action.meta.activity.activityId,
        clientReferenceId: action.meta.clientReferenceId
      })) {
        return state.concat(new MessageFactory({
          content: action.meta.activity.info.activityInfo.content[0].message,
          media: action.meta.activity.info.activityInfo.content[0].media,
          dateTime: action.meta.activity.dateTime,
          direction: action.meta.activity.direction,
          activityId: action.meta.activity.activityId,
          error: false,
          uploadingFile: action.type === `${UPLOAD_FILE}_PENDING`//, UPLOAD_FILE_PROGRESS].indexOf(action.type) > -1 // todo check if still needed
        }));
      }
      return action.type === `${SEND_MESSAGE}_PENDING` ? updateMessage(state, action.meta.clientReferenceId, {error: false}) : state;
    case `${UPLOAD_FILE}_FULFILLED`:
      return updateMessage(state, action.meta.clientReferenceId, {uploadingFile: false, media: [action.payload]});
      // return updateMessage(state, action.meta.clientReferenceId, {uploadingFile: false, media: [Object.assign({}, action.meta.activity.info.activityInfo.content[0].media[0], action.payload)]});
    case `${UPLOAD_FILE_PROGRESS}`:
      return updateMessage(state, action.meta.clientReferenceId, {uploadingFile: true, media: action.meta.activity.info.activityInfo.content[0].media});
    case `${SEND_MESSAGE}_FULFILLED`:
      return onSendFulfilled({
        messages: state,
        clientReferenceId: action.meta.clientReferenceId,
        newId: action.payload.activityId,
        dateTime: action.payload.dateTime
      });
    case `${SEND_MESSAGE}_REJECTED`:
      return onSendRejected({
        messages: state,
        clientReferenceId: action.meta.clientReferenceId
      });
    case `${UPLOAD_FILE}_REJECTED`:
      return onUploadRejected({
        messages: state,
        clientReferenceId: action.meta.clientReferenceId,
        media: action.meta.activity.info.activityInfo.content[0].media[0]
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./chat-app/reducers/conversationHistory.js